<div fxLayout="column" fxLayoutAlign="center center" class="serprobots-message-input-container">

    <div *ngIf="configuration.showInput" fxLayout="row" fxLayoutAlign="center center" [class]="'serprobots-message-input-box ' + getTypographyClass()">

        <textarea
            #input
            id="input"
            *ngIf="configuration.inputMultiline"
            [maxlength]="configuration.inputMaxLength!"
            [(ngModel)]="maskedMessage"
            (keydown)="onKeyDown($event)"
            [disabled]="configuration.disableInput! || disabled"
            [placeholder]="inputPlaceHolder"
            (keyup.enter)="onEnter()"
            name="message"
            value=""
            autocapitalize="none"
            [class]="'full-width form__input ' + getTypographyClass()"
            [style.background-color]="disabled ? 'lightgray':'white'">
        </textarea>
        <input
            #input
            id="input"
            *ngIf="!configuration.inputMultiline"
            [maxlength]="configuration.inputMaxLength!"
            [(ngModel)]="message"
            [disabled]="configuration.disableInput! || disabled"
            [placeholder]="inputPlaceHolder"
            (keyup.enter)="onEnter()"
            [type]="usePassword ? 'password' : 'text'"
            name="message"
            value=""
            autocapitalize="none"
            [class]="'full-width form__input ' + getTypographyClass()"
            [style.background-color]="disabled ? 'lightgray':'white'">

        <button [disabled]="configuration.disableInput! || disabled" type="button" mat-button matSuffix mat-icon-button (click)="send()">
            <mat-icon>{{configuration.sendButtonIcon}}</mat-icon>
        </button>
    </div>

    <div fxLayout="row" [class]="'serprobots-message-input-container-restart-assesment ' + getTypographyClass()">
        <button *ngIf="configuration.showRestart" fxFlex="50" type="button" mat-button (click)="restart()">
            <mat-icon>{{ configuration.restartIcon }}</mat-icon>
            {{ configuration.restartText }}
        </button>
        <button *ngIf="showAssesmentButton" fxFlex="50" type="button" mat-button (click)="showAssesment()">
            <mat-icon>{{ configuration.assesmentButtonIcon }}</mat-icon>
            {{ configuration.assesmentButtonText }}
        </button>
    </div>

</div>
